__turbopack_context__.v({
  "ACCEPTED": "OfferTag-module-scss-module__EdQFGW__ACCEPTED",
  "ACTIVE": "OfferTag-module-scss-module__EdQFGW__ACTIVE",
  "DEAL_CANCELED": "OfferTag-module-scss-module__EdQFGW__DEAL_CANCELED",
  "DECLINED": "OfferTag-module-scss-module__EdQFGW__DECLINED",
  "DELETED": "OfferTag-module-scss-module__EdQFGW__DELETED",
  "NEW": "OfferTag-module-scss-module__EdQFGW__NEW",
  "ON_MODERATION_REGISTRY_TIMEOUT": "OfferTag-module-scss-module__EdQFGW__ON_MODERATION_REGISTRY_TIMEOUT",
  "agreementConclusion": "OfferTag-module-scss-module__EdQFGW__agreementConclusion",
  "documentsPending": "OfferTag-module-scss-module__EdQFGW__documentsPending",
  "sold": "OfferTag-module-scss-module__EdQFGW__sold",
  "urgently": "OfferTag-module-scss-module__EdQFGW__urgently",
  "wrapper": "OfferTag-module-scss-module__EdQFGW__wrapper",
});
